export default {
  name: 'Text'
}
